import "@hotwired/turbo-rails";
import "@hotwired/hotwire-native-bridge";
import "~/controllers";
import { setUpAnalytics } from "~/lib/analytics";
import "~/lib/turbo_stream_actions";

setUpAnalytics();
